import { useMutation } from '@tanstack/react-query'

const flagForReview = async (req: { processId: string; note: string }) => {
  const data = await fetch(
    'https://hooks.zapier.com/hooks/catch/24997072/uj4ft6m/',
    {
      method: 'POST',
      body: JSON.stringify(req)
    }
  )
  return data
}

export const useFlagForReview = () => {
  return useMutation({
    mutationFn: flagForReview
  })
}
